import type { FC } from "react";
import { AdvisorCard } from "web_myplann/Advisor/Components/AdvisorCard";
import { mapAdvisorCardProps } from "web_myplann/Advisor/Mappers/mapAdvisorCardProps";
import type {
	AgentAssignedListItemResponseDTO,
	AgentDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { MissingAdvisor } from "web_myplann/Profile/Components/MissingAdvisor";
import { MyPlannLoading } from "web_myplann/Shared/Components/MyPlannLoading";

type Props = {
	isLoading: boolean;
	selected?: AgentAssignedListItemResponseDTO;
	detail?: AgentDetailResponseDTO;
};

export const AdvisorPageBody: FC<Props> = ({ isLoading, selected, detail }) => {
	if (isLoading) return <MyPlannLoading />;
	if (!selected || !detail?.name) return <MissingAdvisor />;

	return <AdvisorCard key={detail.uid} {...mapAdvisorCardProps(detail)} />;
};
